function Paragraph({children, className = "mb-6"}) {
    return (
      <p className={`font-inter text-md text-center mx-6 sm:mx-0 ${className}`}>{children}</p>
    );
  }
  
  export default Paragraph;
  